import { WIDGET_ORIGIN } from "@/embed/widgetOrigin";

/** Absolute (cross-origin-safe) URL for a same-origin Manly asset under /manly/.
 *  Shares the /manly/ asset directory with the B.O. quiz: the brand assets are
 *  the same, only the funnel differs. Mirrors manly/assets.ts. */
export function assetUrl(file: string): string {
  const base = WIDGET_ORIGIN.replace(/\/+$/, "");
  return `${base}/manly/${file}`;
}

export const PRODUCT_IMAGE = "manly-results.webp";
